import { ProductType } from '@tink/core/src/types';
import { base } from '../lib-api/services/base';

import { ProductDimension } from '../models/product';
import {
  getValidatedUrlParametersByProductType,
  getValidatedUrlParametersByProductTypeRedirect,
} from './urlParametersValidator';
import { applicationParameters } from './application-parameters';
import { postNotificationHandler } from './post-notification-handler';

type AppContextArguments = {
  version: string;
  productType: ProductType;
  productDimension: ProductDimension;
  validateRedirectUrlParameters: boolean;
};

export const setAppContext = ({
  version,
  productType,
  productDimension,
  validateRedirectUrlParameters,
}: AppContextArguments) => {
  base.setVersion(version);
  base.setProduct(productType);

  const { parameters, errors } = validateRedirectUrlParameters
    ? getValidatedUrlParametersByProductTypeRedirect(productType, productDimension)
    : getValidatedUrlParametersByProductType(productType, productDimension);

  applicationParameters.init(parameters);

  base.setSessionId(parameters.trackingId);

  if (parameters.clientId) {
    base.setClientId(parameters.clientId);
  }

  postNotificationHandler.initialize({
    window,
    isIframe: parameters.isIframe,
    redirectUri: parameters.redirectUri as string,
    oauthState: parameters.state,
  });

  return { parameters, parametersValidationError: errors.pop() };
};
